import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FormInputText } from '../../formInputsV2/FormInputText';
import { FormInputCheckbox } from '../../formInputsV2/FormInputCheckbox';
import { FastQuoteLoading } from '../../componentsV2/elements/FastQuoteLoading';
import { Label } from '../../formInputsV2/styles/common';
import { FormInputSelect } from '../../formInputsV2/FormInputSelect';
import {
  km_during_one_year, months, vehicle_plate_types, vehiclesAmountInFamily, years,
} from '../../constants';
import FormReactSelectMotoBrand from '../../formInputsV2/FormReactSelectMotoBrand';
import FormReactSelectMotoModel from '../../formInputsV2/FormReactSelectMotoModel';
import InputSelectTableMoto from '../../componentsV2/inputs/InputTableMoto';
import { FormInputNumber } from '../../formInputsV2/FormInputNumber';
import getAllowedPurchaseYears from '../../helpers/getAllowedPurchaseYears';
import { FormLayout } from '../../formInputsV2/FormLayout.styles';
import CollapsiblePanel from '../../formInputsV2/CollapsiblePanel';
import { WarningButton, WarningHint } from '../../formInputsV2/Button.styles';
import { WarningAlert } from '../../formInputsV2/Alert.styles';

function RcMotoStepOne({
  errors, updateFormData, answers, isValid, checkBoxTypeMoto, isLoadingFastQuote, register, brands, isLoadingVehicleModels, vehicleModels, isLoadingVehicleVersions, vehicleVersions, formData,
  showStepOneFields = false,
  setShowStepOneFields = () => {},
}) {
  return (
    <>
      <FormLayout>
        <div id="vehiclePlateDiv">
          <FormInputText
            error={answers.is_old_plate !== '2' ? errors.moto_plate?.message : undefined}
            label="Targa della moto"
            placeholder="Inserisci la targa"
            onChange={(value) => updateFormData({ moto_plate: value.toUpperCase() })}
            value={answers.moto_plate}
            valid={isValid('moto_plate')}
          />
          {errors.moto_plate?.message && answers.is_old_plate !== '2' && (
            <div className="mt-2 d-flex align-items-center justify-content-center flex-column">
              <WarningButton
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => updateFormData({
                  complete_manually: true,
                  is_old_plate: '2',
                })}
              >
                <FontAwesomeIcon icon={faWarning} />
                {' '}
                Forza Targa (Formato Non Standard)
              </WarningButton>
              <WarningHint>
                Usa il pulsante qui sopra solo se la targa ha un formato non standard.
              </WarningHint>
            </div>
          )}
          {answers.is_old_plate === '2' && (
            <WarningAlert className="alert alert-warning">
              <FontAwesomeIcon icon={faWarning} />
              <span>
                <strong>Targa forzata:</strong>
                {' '}
                Stai utilizzando una targa con formato non standard.
              </span>
            </WarningAlert>
          )}
        </div>

        <FormInputSelect
          registration={register('is_old_plate')}
          error={errors.is_old_plate?.message}
          valid={isValid('is_old_plate')}
          placeholder="-Tipo-"
          options={vehicle_plate_types}
          label="Tipo di Targa"
          onChange={(e) => {
            const value = e.target.value;
            if (value === '2') {
              updateFormData({
                is_old_plate: value,
                complete_manually: true,
              });
            }
          }}
        />

        {(isValid('moto_plate') === true || answers.is_old_plate === '2')
          && (
            <div className="d-flex justify-content-center align-items-center gap-2 gap-md-5" ref={checkBoxTypeMoto} id="checkBoxType">

              <FormInputCheckbox
                label=" Veicolo già assicurato?"
                checked={answers.renew_check}
                onChange={() => updateFormData({
                  renew_check: !answers.renew_check,
                  insurance_type: !answers.renew_check ? 'B' : '',
                  new_risks_check: false,
                  complete_manually: answers.is_old_plate === '2',
                })}
              />

              <FormInputCheckbox
                label=" Nuovo rischio?"
                checked={answers.new_risks_check}
                onChange={() => updateFormData({
                  new_risks_check: !answers.new_risks_check,
                  renew_check: false,
                  insurance_type: !answers.new_risks_check ? 'N' : '',
                  complete_manually: answers.is_old_plate === '2',
                })}
              />
            </div>
          )}
      </FormLayout>

      {isLoadingFastQuote === true && <FastQuoteLoading />}

      {answers.moto_plate !== ''
        && (!errors.moto_plate?.message || answers.is_old_plate === '2')
        && (answers.renew_check || answers.new_risks_check)
        && (answers.start_immatricolation !== ''
          || answers.complete_manually === true) && (
          <FormLayout id="nextInputsImmatricolationBrand">
            <div className="row mt-2">
              <Label as="span">Data di prima immatricolazione</Label>
              <div className="col-12 col-md-8">
                <FormInputSelect
                  registration={register('start_immatricolation_month')}
                  error={errors.start_immatricolation_month?.message}
                  valid={isValid('start_immatricolation_month')}
                  placeholder="-Mese-"
                  options={months}
                />
              </div>

              <div className="col-12 col-md-4">
                <FormInputSelect
                  registration={register('start_immatricolation')}
                  error={errors.start_immatricolation?.message}
                  valid={isValid('start_immatricolation')}
                  placeholder="-Anno-"
                  options={years}
                />
              </div>
            </div>

            <FormReactSelectMotoBrand
              label="Marca"
              values={{
                moto_brand_code: answers.moto_brand_code,
              }}
              error={errors.moto_brand_code?.message}
              valid={isValid('moto_brand_code')}
              onChange={(item) => updateFormData({
                moto_brand_code: item.moto_brand_code,
              })}
              options={brands}
            />
          </FormLayout>
      )}

      {answers.moto_brand_code ? (
        <>
          {answers.moto_brand_code && (
            <FormLayout id="nextInputModel">
              {isLoadingVehicleModels ? (
                <p className="text-center">Attendere prego...</p>
              ) : (
                <FormReactSelectMotoModel
                  label="Modello"
                  values={{
                    moto_model_code: answers.moto_model_code,
                  }}
                  error={errors.moto_model_code?.message}
                  valid={isValid('moto_model_code')}
                  onChange={(item) => {
                    updateFormData({
                      moto_model_code: item.moto_model_code,
                    });
                  }}
                  options={vehicleModels}
                />
              )}
            </FormLayout>
          )}

          {answers.moto_brand_code && answers.moto_model_code ? (
            isLoadingVehicleVersions ? (
              <p className="text-center">Attendere prego...</p>
            ) : answers.moto_model_code && vehicleVersions.length > 0 ? (
              <FormLayout id="versionCode">
                <InputSelectTableMoto
                  TableHeader={(
                    <div className="d-flex">
                      <div className="col-6">Descrizione</div>
                      <div className="col-6">Data Vehicolo</div>
                    </div>
                  )}
                  label="Versione"
                  name="moto_version_code"
                  id="moto_version_code"
                  options={vehicleVersions}
                  selected={answers.moto_version_code}
                  error={errors.moto_version_code?.message}
                  valid={isValid('moto_version_code')}
                  onSelectOption={(value) => updateFormData({
                    moto_version_code: value.id,
                    prg_code_moto: value.prg_code_moto,
                  })}
                />
              </FormLayout>
            ) : (
              <div className="alert-general-error">
                Nessuna versione trovata per questo modello!
              </div>
            )
          ) : (
            ''
          )}

          {answers.moto_version_code && (
            <FormLayout id="restInputsStepOne">
              <hr />
              <CollapsiblePanel
                open={showStepOneFields}
                onToggle={() => setShowStepOneFields(!showStepOneFields)}
                openLabel="Detagli"
                closedLabel="Detagli"
              >
                <FormInputNumber
                  registration={register('weight')}
                  error={errors.weight?.message}
                  valid={isValid('weight')}
                  label="Peso dell'moto"
                  placeholder="Inserisci il peso in kg"
                />
                <FormInputNumber
                  registration={register('power')}
                  error={errors.power?.message}
                  valid={isValid('power')}
                  label="Potenza in kW"
                  placeholder="Inserisci la potenza in kW"
                />
                <FormInputSelect
                  label="Parcheggio moto"
                  registration={register('vehicle_parking')}
                  error={errors.vehicle_parking?.message}
                  valid={isValid('vehicle_parking')}
                  placeholder="-Seleziona-"
                  options={formData.parking_types}
                />
                <FormInputSelect
                  label="Antifurto"
                  registration={register('theft_protection_code')}
                  error={errors.theft_protection_code?.message}
                  valid={isValid('theft_protection_code')}
                  placeholder="-Seleziona-"
                  options={formData.theft_protections}
                />
                <FormInputSelect
                  label="Utilizzo"
                  registration={register('vehicle_usage')}
                  error={errors.vehicle_usage?.message}
                  valid={isValid('vehicle_usage')}
                  placeholder="-Seleziona-"
                  options={formData.vehicle_usage_types.filter(
                    (type) => type.vehicle_type === 'auto',
                  )}
                />
                <FormInputSelect
                  label="Km percorsi in un anno"
                  registration={register('predicted_km')}
                  error={errors.predicted_km?.message}
                  valid={isValid('predicted_km')}
                  placeholder="-Seleziona-"
                  options={km_during_one_year}
                />
                <FormInputSelect
                  label="Auto nel nucleo familiare"
                  registration={register('vehicles_owned')}
                  error={errors.vehicles_owned?.message}
                  valid={isValid('vehicles_owned')}
                  placeholder="-Seleziona-"
                  options={vehiclesAmountInFamily}
                />
              </CollapsiblePanel>

              {answers.start_immatricolation !== '' && (
                <div className="row mt-2">
                  <Label as="span">Mese e anno in cui hai comprato l'moto</Label>
                  <div className="col-12 col-md-8">
                    <FormInputSelect
                      registration={register('vehicle_purchased_month')}
                      error={errors.vehicle_purchased_month?.message}
                      valid={isValid('vehicle_purchased_month')}
                      placeholder="-Mese-"
                      options={months}
                    />
                  </div>

                  <div className="col-12 col-md-4">
                    <FormInputSelect
                      registration={register('vehicle_purchased_year')}
                      error={errors.vehicle_purchased_year?.message}
                      valid={isValid('vehicle_purchased_year')}
                      placeholder="-Anno-"
                      options={getAllowedPurchaseYears(
                        answers.start_immatricolation,
                      )}
                    />
                  </div>
                </div>
              )}
            </FormLayout>
          )}
        </>
      ) : (
        ''
      )}
    </>
  );
}

export default RcMotoStepOne;
